const sanitizeHtml = require('sanitize-html');
const { ensureTrailingSlashLocal, isLocal } = require('./ensureTrailingSlash');
const sanitize = (html, options = {}) =>
  sanitizeHtml(html, {
    allowedTags: [
      'h1',
      'button',
      'img',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'p',
      'a',
      'ul',
      'ol',
      'nl',
      'li',
      'b',
      'i',
      'strong',
      'em',
      'strike',
      'code',
      'hr',
      'br',
      'div',
      'table',
      'thead',
      'caption',
      'tbody',
      'tr',
      'th',
      'td',
      'pre',
      'iframe',
      'figure',
      'zapier-app-directory',
      'zapier-zap-templates',
      'zapier-full-experience',
    ],
    allowedAttributes: {
      a: ['href', 'name', 'target', 'rel'],
      // We don't currently allow img itself by default, but this
      // would make sense if we did. You could add srcset here,
      // and if you do the URL is checked for safety
      img: ['src', 'class', 'alt'],
      '*': [
        'data-*',
        'class',
        'alt',
        'src',
        'href',
        'id',
        'style',
        'width',
        'height',
        'allowfullscreen',
        'frameborder',
      ],
      'zapier-app-directory': ['*'],
      'zapier-zap-templates': ['*'],
      'zapier-full-experience': ['*'],
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
      'img',
      'br',
      'hr',
      'area',
      'base',
      'basefont',
      'input',
      'link',
      'meta',
    ],
    // URL schemes we permit
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowProtocolRelative: true,
    transformTags: {
      a: (tagName, attribs) => {
        if (!attribs.rel) {
          attribs.rel = '';
        }
        if (!attribs.rel.includes('noopener')) {
          attribs.rel += ' noopener';
        }

        // eslint-disable-next-line no-script-url
        if (!attribs.href || attribs.href.startsWith('javascript:')) {
          attribs.href = '';
        }
        if (!isLocal(attribs.href)) {
          attribs.target = '_blank';
        }
        attribs.href = ensureTrailingSlashLocal(attribs.href);

        return {
          tagName,
          attribs,
        };
      },
    },
    ...options,
  });

module.exports = sanitize;
